import { ReactElement } from 'react'
import { useFormContext, useFormState, useWatch } from 'react-hook-form'
import { TextField, UploadField } from '@ui/forms'
import SubmitButton from '@ui/forms/SubmitButton'

interface Props {
  isLoading: boolean
}

const FormFields = ({ isLoading }: Props): ReactElement => {
  const currentTitle = useWatch({ name: 'title' })
  const { setValue } = useFormContext()
  const { defaultValues } = useFormState()

  return (
    <>
      <TextField name="name" placeholder="Name" />
      <UploadField
        name="file"
        accept={{
          'application/pdf': [],
          'application/msword': [],
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
        }}
        onSelect={file => {
          if (currentTitle === defaultValues?.title) {
            setValue('name', file.name)
          }
        }}
      />
      <SubmitButton loading={isLoading} text="Hochladen" disableIfNotDirty={false} />
    </>
  )
}

export default FormFields
